import { render } from "./DateInput.vue?vue&type=template&id=2a6a5bbf"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.3.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__